import { sortSelectStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

styles.select = {
    ...styles.select,
    labelProps: {
        css: css`
            padding: 0;
        `,
    },
    cssOverrides: {
        ...styles.select?.cssOverrides,
        formField: css`
            width: 100%;
            display: flex;
            align-items: center;
            gap: 10px;
            justify-content: flex-end;

            label {
                width: auto;
                min-width: 50px;
            }
        `,
        formInputWrapper: css`
            width: auto;
        `,
    },
};
